import type { Bookmaker } from '../types';

interface Props {
  bookmakerCount: number;
  bookmakers: Bookmaker[];
  onStart: () => void;
}

// Race-themed ticker tape sliding across the bottom of the dark landing card.
function TickerTape({ bookmakers }: { bookmakers: Bookmaker[] }) {
  const lines = bookmakers.slice(0, 14).map((b, i) => {
    const samples = [
      `🏇 ${b.name} \u00B7 14:30 Cheltenham \u00B7 free bet from £5`,
      `🏁 ${b.name} matched a punter ${i + 2}m ago`,
      `🐎 ${b.name} \u00B7 £30+ welcome free bet live`,
      `📰 ${b.name} \u00B7 each-way special running today`,
    ];
    return samples[i % samples.length];
  });
  const stream = [...lines, ...lines];

  return (
    <div className="fb-ticker" aria-hidden="true">
      <div className="fb-ticker__rail">
        {stream.map((s, i) => (
          <span key={i} className="fb-ticker__item">
            <span className="fb-ticker__dot" /> {s}
          </span>
        ))}
      </div>
    </div>
  );
}

export function Landing({ bookmakerCount, bookmakers, onStart }: Props) {
  return (
    <section className="fb-step fb-landing" aria-labelledby="fb-landing-heading">
      <div className="fb-landing__paddock" aria-hidden="true">
        <span className="fb-landing__paddock-horse">🐎</span>
      </div>
      <div className="fb-landing__content">
        <span className="fb-landing__pill">🏇 5-Furlong Sprint</span>
        <h1 id="fb-landing-heading" className="fb-landing__heading">
          Race to the free bet that fits how you bet.
        </h1>
        <p className="fb-landing__sub">
          Five furlongs. Five quick questions. Your horse runs while we match
          you to the strongest free-bet offers from UKGC-licensed bookmakers.
        </p>
        <button type="button" className="fb-landing__cta fb-landing__cta--pulse" onClick={onStart}>
          🏁 To the start line →
        </button>
        {bookmakerCount > 0 && (
          <p className="fb-landing__count">
            <span className="fb-landing__count-num">{bookmakerCount}</span> live offers ·
            updated weekly · 18+ · #ad
          </p>
        )}
      </div>
      {bookmakers.length > 0 && <TickerTape bookmakers={bookmakers} />}
    </section>
  );
}
